import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../Header/Header";
import SideBar from "../../../SideBar/SideBar";
import Footer from "../../../Footer/Footer";
import './universityChat.css'
import { deleteApplication, getAllUserApplications, getAllUserApplicationsBasedOnStatus, updateApplication } from "../../../HttpRequest/applyapplication";
import Pagination from "../../Base UI/Pagination";
import { applicationWithDraw, cancelButton } from "../../Base UI Elements/SweetAlert";



export default function UniversityChatCardComponent(passingUserId) {

  const [universitychat, setuniversitychat] = useState({
    recentchat: true,
  })
  const [data, setData] = useState([]);
  const [pagedata, setpagedata] = useState();
  const [checkedIndex, setCheckedIndex] = useState(1);
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    size: 10,
  });

  const deleteApplicationFunction = async (id) => {
    cancelButton(async (userClickedYes) => {
      if (userClickedYes) {
        try {
          console.log("delete is calling-->", id);
          const response = await deleteApplication(id);
          console.log("delete is done...!", response);
          if (response.status === 204) {
            console.log("delete is successful!");
            fetchData();
          } else {
            console.log("data error");
          }
        } catch (error) {
          console.error("Error during delete:", error);
        }
      } else {
        console.log("User clicked No or dismissed the dialog");
      }
    });
  };

  const withDrawApplicationFunction = async (item) => {
    console.log("with dram data-->", item)
    item.status = 'with-draw'
    applicationWithDraw(async (userClickedYes) => {
      if (userClickedYes) {
        try {
          const response = await updateApplication(item.id, item);
          if (response.status === 201 || response.status === 200) {
            fetchData();
          } else {
            console.log("data error");
          }
        } catch (error) {
          console.error("Error during delete:", error);
        }
      } else {
        console.log("User clicked No or dismissed the dialog");
      }
    });
  };

  const filterApplicationsBasedOnStatus = async (index, Status) => {

    const userId = localStorage.getItem("id")
    getAllUserApplicationsBasedOnStatus(userId, Status,pageInfo.page,pageInfo.size).then(response => {
      console.log("filter responce-->", response)
      if (response.request.status == 200 || response.request.status == 201) {
        setpagedata(response.data.metaData);
        setData(response.data);
        setCheckedIndex(index);
      }
    })

    // applicationWithDraw(async (userClickedYes) => {
    //   if (userClickedYes) {
    //     try {
    //       const response = await updateApplication(item.id, item);
    //       if (response.status === 201 || response.status === 200) {
    //         fetchData();
    //       } else {
    //         console.log("data error");
    //       }
    //     } catch (error) {
    //       console.error("Error during delete:", error);
    //     }
    //   } else {
    //     console.log("User clicked No or dismissed the dialog");
    //   }
    // });
  };


  useEffect(() => {
    fetchData();
  }, [pageInfo]);


  const fetchData = async () => {
    let userId ="";
    try {
      if(localStorage.getItem("userRole") === "admin"){
        const id = passingUserId.location.state;
        userId = id.passingUserId;
        console.log("userId in the all university==>",userId);
      }else{
        userId = localStorage.getItem("id");
      }
      const response = getAllUserApplications(userId,pageInfo.page,pageInfo.size);
      response.then((data) => {
        console.log('User applied applications===>', data);
        if (data.request.status == 200) {
          setpagedata(data.data.metaData);
          setData(data.data);
          setCheckedIndex(1);
        } else {
          console.log("data error")
        }
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const setPageInfoData = (data) => {
    setPageInfo({
      page: data.currentPage,
      size: data.pageSize,
    });
  };

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">My Applications </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">My Applications</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="card card-table">
              <div className="card-body">
                {/* Page Header */}

                {/* /Page Header */}

                {/* <input className="form-control" placeholder="Enter the" /> */}
                {/* <div className="-search searchunivercitybox">
                  <i className="fas fa-search"></i>
                </div> */}
                <div className="checkboxgroup" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox1"
                      value="option1"
                      checked={checkedIndex === 1}
                      onClick={() => { fetchData() }} />
                    <label class="form-check-label" for="inlineCheckbox1"> All Applications
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox2"
                      value="option2"
                      checked={checkedIndex === 2}
                      onClick={() => { filterApplicationsBasedOnStatus(2, 'approve-and-assign') }} />
                    <label class="form-check-label" for="inlineCheckbox2">Approve & Assigned</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox3"
                      value="option3"
                      checked={checkedIndex === 3}
                      onClick={() => { filterApplicationsBasedOnStatus(3, 'application-submitted') }} />
                    <label class="form-check-label" for="inlineCheckbox3">On-Going Applications</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox4"
                      value="option4"
                      checked={checkedIndex === 4}
                      onClick={() => { filterApplicationsBasedOnStatus(4, 'reject') }} />
                    <label class="form-check-label" for="inlineCheckbox4">Rejected Applications</label>
                  </div>
                </div>
                <div className="row col-12">
                  <div className="chatgrop" style={{justifyContent:"start"}}>
                    {data.data?.map(item => (
                      <div className="chatcards" key={item.applicationId}>
                        <div className="apliactionid" >
                          Application Id: {item.applicationId}
                        </div>
                        <div className="cardunivercityname">
                          <p><i class="fa-solid fa-school fw-bold"></i> <strong>{item.name}</strong></p>
                          <p><i class="fa-solid fa-graduation-cap fw-bold"></i> {item.university}</p>
                          <p><i class="fa-solid fa-calendar-days fw-bold"></i> <strong>Year :{item.year}  </strong></p>
                          <p><i class="fa-solid fa-floppy-disk fw-bold"></i> <strong>{item.intakes}</strong></p>
                          <p><i class="fa-solid fa-school fw-bold"></i> <strong>Status : {item.status}</strong></p>
                        </div>
                        <div className="boxcontainer1">
                          <div type="button" className="h5 m-0" title="With Draw Application" onClick={() => withDrawApplicationFunction(item)}>
                            <i class="fa-solid fa-rectangle-xmark text-primary"></i>
                          </div>
                          <Link to={{ pathname: '/chatsupport', state: { applicationDetails: item } }} ><div className="boxcontai">
                            <i class="fa-regular fa-comment"></i>  Chat With Us!
                          </div></Link>
                          <div type="button" className="h5  m-0" onClick={() => deleteApplicationFunction(item.id)}>
                            <i class="fa-solid fa-trash text-danger"></i>
                          </div>
                        </div>
                      </div>
                    ))}
                    {universitychat.recentchat ? <>
                    </> : <>

                      <div class="card chatuniversity">
                        <div class="card-header   univercitycard-header">
                          <div>Recent chat</div>

                          <i className="fas fa-search"></i>
                        </div>
                        <div class="card-body chatunivercit">
                          <h6   >New york institute of technology</h6>
                          <div className="universitychatcard">
                            <div><strong>Intake</strong> : Spring</div>
                            <div><strong>Year</strong>  : 2023</div>
                          </div>
                          <hr></hr>

                          <h6   >New york institute of technology</h6>
                          <div className="universitychatcard">
                            <div><strong>Intake</strong> : Spring</div>
                            <div><strong>Year</strong>  : 2023</div>
                          </div>
                          <hr></hr>

                          <h6   >New york institute of technology</h6>
                          <div className="universitychatcard">
                            <div><strong>Intake</strong> : Spring</div>
                            <div><strong>Year</strong>  : 2023</div>
                          </div>
                        </div>
                      </div></>}
                    {/* <div className="chatcards"></div>
                    <div className="chatcards"></div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {pagedata && <Pagination pageResponce={pagedata} pagedataToParent={setPageInfoData} />}
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
}
